const mockPhotos = [
    {
        id: "p1",
        title: "Festival Aura",
        category: "Cobertura de evento",
        image:
            "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p2",
        title: "Summit Experience",
        category: "Brand experience",
        image:
            "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p3",
        title: "Noite Prisma",
        category: "Live performance",
        image:
            "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p4",
        title: "Conferência Axis",
        category: "Institucional",
        image:
            "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p5",
        title: "Experience Gala",
        category: "Social experience",
        image:
            "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p6",
        title: "Launch Session",
        category: "Campanha / ativação",
        image:
            "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },

    {
        id: "p7",
        title: "Sunset Edition",
        category: "Cobertura de evento",
        image:
            "https://images.unsplash.com/photo-1505236858219-8359eb29e329?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p8",
        title: "Vision Forum",
        category: "Brand experience",
        image:
            "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p9",
        title: "Pulse Stage",
        category: "Live performance",
        image:
            "https://images.unsplash.com/photo-1506157786151-b8491531f063?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p10",
        title: "Corporate Night",
        category: "Institucional",
        image:
            "https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p11",
        title: "Maison Event",
        category: "Social experience",
        image:
            "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p12",
        title: "Brand Reveal",
        category: "Campanha / ativação",
        image:
            "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },

    {
        id: "p13",
        title: "Motion Week",
        category: "Cobertura de evento",
        image:
            "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p14",
        title: "Nexus Expo",
        category: "Brand experience",
        image:
            "https://images.unsplash.com/photo-1515169067868-5387ec356754?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p15",
        title: "Echo Session",
        category: "Live performance",
        image:
            "https://images.unsplash.com/photo-1503095396549-807759245b35?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p16",
        title: "Prime Meeting",
        category: "Institucional",
        image:
            "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p17",
        title: "Golden Reception",
        category: "Social experience",
        image:
            "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p18",
        title: "Activation Room",
        category: "Campanha / ativação",
        image:
            "https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },

    {
        id: "p19",
        title: "Urban Lights",
        category: "Cobertura de evento",
        image:
            "https://images.unsplash.com/photo-1496024840928-4c417adf211d?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p20",
        title: "Immersion Day",
        category: "Brand experience",
        image:
            "https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
    {
        id: "p21",
        title: "Electric Stage",
        category: "Live performance",
        image:
            "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1600&auto=format&fit=crop",
        size: "small",
    },
];

export default mockPhotos;